/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 17:02:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-25 13:20:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/Summary/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
// import { DiscountType } from '@/src/types/common/discount';
import { Form } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  i18nGet,
  replaceI18nVariables,
  replaceI8nSequence,
  handleOnFormatCurrentSCTimeAndDate,
} from 'src/tools/tools';
import { EnumStatus } from 'src/types/common/discount';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { DiscountValueType } from '../../../Components/AtDiscountValue';
import { ECondition } from '../../../Components/CustomerEligibleCondition';
import {
  EApplyTo,
  EProductsMatchRule,
  EType,
} from '../../../Components/OrderEligibleCondition/EligibleCard';
import SummaryComponent from '../../../Components/Summary';
import { ProductsOptionsType } from '../CustomerGets';
import css from '../css.module.less';
interface IProps {
  status?: string;
  activeTime?: any;
}
const Summary = ({ status, activeTime }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    beginDate = '',
    beginTime = '',
    endDate = '',
    endTime = '',
  } = activeTime;
  const isMini = useSalesChannelIsMiniProgram();

  const renderSummaryData = (getFieldsValue) => {
    const begin = beginDate
      ? handleOnFormatCurrentSCTimeAndDate(beginDate + ' ' + beginTime)
      : '';
    const end = endDate
      ? handleOnFormatCurrentSCTimeAndDate(endDate + ' ' + endTime)
      : '';
    const {
      codes,
      autoCombineDisabled,
      codeCombineDisabled,
      discountMethod = {},
      applyTo = {},
      customerCondition = {},
      userLimitation = {},
      conditions = {},
      currencyCode,
    } = getFieldsValue([
      'codes',
      'autoCombineDisabled',
      'codeCombineDisabled',
      'discountMethod',
      'applyTo',
      'customerCondition',
      'userLimitation',
      'conditions',
      'currencyCode',
    ]);

    const {
      getsQty,
      purchaseItemScope,
      maxSelection,
      discountValue,
      percentage,
      reductionAmount,
      purchaseType,
    } = discountMethod;
    const { conditions: conditionsAll = [] } = conditions;
    const { cumulative = '' } = applyTo || {};
    const { conditionType } = customerCondition;
    const { maxInTotal = '', maxPerCustomer = '' } = userLimitation;
    const _purchaseItemScope =
      purchaseItemScope === ProductsOptionsType.Products
        ? getI18n('general.products')
        : getI18n('general.collections');
    const autoCombine =
      autoCombineDisabled || codeCombineDisabled
        ? autoCombineDisabled && codeCombineDisabled
          ? getI18n(
              'salesChannelDirectDiscount.summary.cannotcombinewithotherdiscounts',
            )
          : autoCombineDisabled
          ? getI18n(
              'salesChannelDirectDiscount.summary.cannotcombinewithotherautomaticdiscounts',
            )
          : getI18n(
              'salesChannelDirectDiscount.summary.cannotcombinewithotherpromocodediscounts',
            )
        : '';
    const purchaseTypeText = {
      [EProductsMatchRule.All]: getI18n('salesChannelGiftPurchase.summary.all'),
      [EProductsMatchRule.Any]: getI18n('salesChannelGiftPurchase.summary.any'),
    };

    const discountMethodText = {
      [DiscountValueType.Free]:
        purchaseType === EProductsMatchRule.All
          ? replaceI8nSequence(
              getI18n('salesChannelGiftPurchase.summary.customerwillget'),
              getsQty,
              _purchaseItemScope,
              purchaseTypeText[purchaseType],
            )
          : replaceI8nSequence(
              getI18n('salesChannelGiftPurchase.summary.customerGetAny'),
              getsQty,
              _purchaseItemScope,
              purchaseTypeText[purchaseType],
            ),
      [DiscountValueType.Percentage]: replaceI8nSequence(
        getI18n('salesChannelGiftPurchase.summary.customerCanGet'),
        getsQty,
        _purchaseItemScope,
        percentage || 0,
        purchaseTypeText[purchaseType],
      ),
      [DiscountValueType.Reduction]: replaceI8nSequence(
        getI18n('salesChannelGiftPurchase.summary.reduction'),
        getsQty,
        _purchaseItemScope,
        reductionAmount || 0,
        purchaseTypeText[purchaseType],
      ),
    };
    const customerConditionText = {
      [ECondition.Everyone]: getI18n(
        'salesChannelDirectDiscount.summary.foreveryone',
      ),
      [ECondition.Registered]: getI18n(
        'salesChannelDirectDiscount.summary.forregisteredcustomers',
      ),
      [ECondition.Specific]: getI18n(
        'salesChannelDirectDiscount.summary.forspecificcustomers',
      ),
    };
    const conditionsApplyToText = {
      [EApplyTo.All]: `${getI18n(
        'salesChannelDirectDiscount.discountValuebuyOne.allProducts',
      )} `,
      [EApplyTo.Collections]: {
        [EProductsMatchRule.Any]: getI18n(
          'salesChannelGiftPurchase.summary.anyofspecificcollection',
        ),
        [EProductsMatchRule.All]: getI18n(
          'salesChannelGiftPurchase.summary.allofspecificcollection',
        ),
      },
      [EApplyTo.Products]: {
        [EProductsMatchRule.Any]: getI18n(
          'salesChannelGiftPurchase.summary.anyofspecificproducts',
        ),
        [EProductsMatchRule.All]: getI18n(
          'salesChannelGiftPurchase.summary.allofspecificproducts',
        ),
      },
    };

    const multiConditions = `${getI18n(
      'salesChannelDirectDiscount.summary.allCondition',
    )}: `;
    const conditionsAllText = (conditionsAll || [])
      .map((item) => {
        if (!item.minimum) {
          return '';
        }
        const isCount = item.basedOn !== EType.Value;
        const isLargeThan = item.minimum && !item.maximum;
        const text1 = isCount
          ? getI18n('salesChannelGiftPurchase.summary.quantityof')
          : getI18n('salesChannelGiftPurchase.summary.amountof');

        const text2 =
          item.applyTo === EApplyTo.All
            ? conditionsApplyToText[EApplyTo.All]
            : conditionsApplyToText[item.applyTo][item.matchRule];

        const unit = isCount ? '' : '$';
        const minimum = `${unit}${item.minimum}`;
        const maximum = `${unit}${item.maximum}`;

        const text5 = item.flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : '';
        const text0 = replaceI8nSequence(
          getI18n(
            isLargeThan
              ? 'salesChannelGiftPurchase.summary.conditionsTextLargeThan'
              : 'salesChannelGiftPurchase.summary.conditionsTextFromTo',
          ),
          text1,
          text2,
          minimum,
          maximum,
        );

        return `${text0} ${text5}`;
      })
      .filter((o) => o !== '');
    const summaryData = [
      ...(currencyCode && !isMini
        ? [`${getI18n('general.applicableCurrency')} ${currencyCode}`]
        : []),
      ...(begin
        ? [
            `${replaceI18nVariables(
              getI18n('salesChannelDirectDiscount.summary.validfrom'),
              begin,
            )} ${
              end
                ? ` ${getI18n('general.to')} ${end}`
                : ` , ${getI18n(
                    'salesChannelDirectDiscount.summary.noenddate',
                  )}`
            }`,
          ]
        : []),
      ...(codes && codes.length
        ? [
            `${codes.length} ${getI18n('general.promocodes')}`,
            ...(autoCombine ? [autoCombine] : []),
          ]
        : []),
      ...(getsQty ? [discountMethodText[discountValue]] : []),
      ...(cumulative
        ? [getI18n('salesChannelGiftPurchase.summary.condiMet')]
        : []),
      ...(maxSelection
        ? [
            replaceI18nVariables(
              getI18n('salesChannelGiftPurchase.summary.limitOrder'),
              maxSelection,
            ),
          ]
        : []),
      ...(conditionType ? [customerConditionText[conditionType]] : []),
      ...(maxInTotal || maxPerCustomer
        ? [
            maxInTotal && maxPerCustomer
              ? replaceI18nVariables(
                  getI18n('salesChannelGiftPurchase.summary.limitInTotal'),
                  maxInTotal,
                  maxPerCustomer,
                )
              : !maxInTotal && maxPerCustomer
              ? replaceI18nVariables(
                  getI18n('salesChannelGiftPurchase.summary.limitiUse'),
                  maxPerCustomer,
                )
              : replaceI18nVariables(
                  getI18n('salesChannelGiftPurchase.summary.limitUseinTotal'),
                  maxInTotal,
                ),
          ]
        : []),
      ...((conditionsAll || []).length >= 2 ? [multiConditions] : []),
      ...((conditionsAll || []).length ? conditionsAllText : []),
    ];
    return summaryData;
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        title={getI18n('general.summary')}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue, getFieldsValue }) => {
            return (
              <SummaryComponent
                name={getFieldValue('name')}
                status={status || EnumStatus.Draft}
                summaryContent={renderSummaryData(getFieldsValue)}
              />
            );
          }}
        </Form.Item>
      </SectionWrapper>
    </div>
  );
};

export default Summary;
